import * as React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
// graphql
import { COMPANIES_LIST_QUERY } from 'graphql/company/queries'
// types
import { ICompany } from 'types/graphql'
import { NGetCompanies } from 'types/companies/helpets'
import { TRefetch } from 'types/refetch'
// utils
import get from 'lodash/get'

type Props = React.PropsWithChildren<unknown>

interface IContext {
  data: ICompany[]
  refetch: TRefetch<NGetCompanies.IResponse, NGetCompanies.IVariables>
  isLoading: boolean
  totalCount: number
  isRefetching: boolean
}

export const AccountsPageContext = React.createContext<IContext>({} as any)

const AccountsPageAPI: React.FC<Props> = ({ children }) => {
  const { page, perPage, search } = React.useContext(TableManagementContext)

  const { data, networkStatus, refetch } = useQuery(COMPANIES_LIST_QUERY, {
    variables: {
      filter: {
        name: search
      },
      pagination: {
        pageSkip: page * perPage,
        pageTake: perPage
      }
    }
  })

  const companies = get(data, 'companies.data', [])
  const totalCount = get(data, 'companies.pagination.totalCount')

  const value = {
    refetch,
    totalCount,
    data: companies,
    isLoading: networkStatus === 1,
    isRefetching: networkStatus === 2
  } as any

  return <AccountsPageContext.Provider value={value}>{children}</AccountsPageContext.Provider>
}

export default AccountsPageAPI
